export default __webpack_public_path__ + "static/media/group-3-copy-3@2x.6027638a.png";